// context/actionTypes.js
export const SET_MENUS = 'SET_MENUS';
export const SET_USER_CHOICES = 'SET_USER_CHOICES';
export const SET_MAIN_CATEGORY_ID = 'SET_MAIN_CATEGORY_ID';
export const SET_MAIN_CATEGORY_NAME = 'SET_MAIN_CATEGORY_NAME';
export const SET_ACTIVE_MENU = 'SET_ACTIVE_MENU';
export const SET_ACTIVE_SUB_MENU = 'SET_ACTIVE_SUB_MENU';
export const SET_SUB_CATEGORY_ID = 'SET_SUB_CATEGORY_ID';
export const SET_ITEM_CHOICES = 'SET_ITEM_CHOICES';
export const SET_CHOSEN_CATEGORY = 'SET_CHOSEN_CATEGORY';
export const SET_FILTERED_ITEMS = 'SET_FILTERED_ITEMS';
export const SET_TOTAL_MONTH_PRICE = 'SET_TOTAL_MONTH_PRICE';
export const SET_ORDER = 'SET_ORDER';
